import { Component, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { ReportService } from "../../reportService";
import { DataService } from "../../dataService";
import { Subscription, Subject } from 'rxjs';
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from 'rxjs/operators';
import { IPopupLink, IReportsColumnModel, ReportsAuditRoutes } from "../../models/reports.models";
import { IReportsFilterModel, ReportsColumnDataType } from "../../models/reports-filter.models";
import { AppMainComponent } from "../../../app.main.component";
import { AppMainService } from "../../../app-main.service";
import { ParseHelper } from "../../../modules/shared/parse.helper";
import { LocalDatePipe } from './../../../shared/pipes/local-date.pipe';
import { ReportsAuditLabelName } from "../../models/reports-audit.models";
import * as moment from "moment";
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from "../../models/reports-data-service-model";
import { ReportsPrintPdfService } from "../../servies/reports-print-pdf.service";
import { ReportsExportExcelService } from "../../servies/reports-export-excel.service";

@Component({
    selector: 'app-reports-audit',
    templateUrl: './reports-audit.component.html',
})

export class ReportsAuditComponent implements OnInit, OnDestroy {

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    public selectedWindow: string = '';
    public reportName: string = '';
    public organizationName = "";
    public dateFrom: any;
    public dateTo: any;
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedOppStageFilter = { name: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateCasesChannelfilter = { name: "All", id: 0 };
    public selectedDatePipelineFilter = { name: "All", id: 0 };
    public filterByInputValue: any[] = [];
    public selectedFilterGroup: IReportsFilterModel[] = [];
    public cols: IReportsColumnModel[] = [];
    public tableCols: IReportsColumnModel[] = [];
    public reportsData: any[] = [];
    public reportsDataCopy = [];

    public showRows: number = 15;
    public pageSize = 15;
    public pageNumber = 1;
    first = 0;
    reportsTotalRecord: number = 0;
    channelList: any[] = [];
    currentDateTime = new Date();
    moduleList: any[] = [];
    selectedModule: any = null;
    selectedChannel: any = null;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    selectedChannelId: number = 0;
    displayLeadViewEdit: boolean = false;
    selectedLeadId: number = 0;

    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private dataService: DataService,
        public localDatePipe: LocalDatePipe,
        private router: ActivatedRoute,

    ) {
        //set timezone date
        this.dateFrom = this.app._showDateTimeWithZone(new Date());
        this.dateTo = this.app._showDateTimeWithZone(new Date());
        //*************Pring & Export(PDF/Excel)****************
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.refreshList(this.selectedWindow)
                }
            }
        });
    }

    async ngOnInit() {
        this.dateFrom = this.app._showDateTimeWithZone(new Date());
        this.dateTo = this.app._showDateTimeWithZone(new Date());
        this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
            const reportType: string = param.params.type;
            if (reportType) {
                let currentRoute = ReportsAuditRoutes[reportType];
                this.selectedWindow = reportType;
                this.reportName = ReportsAuditLabelName[reportType];
                // switch (activityType) {
                //     case ReportsAuditRoutes["audit-report"]:
                //         this.selectedWindow = "audit";
                //         this.reportName = 'Audit Report';
                //         break;
                //     default:
                //         break;
                // }
            }
            //Send To Parent Component For Left Menu Expand
            this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
        });
        await this.getAuditReportModule();
    }
    ngOnChanges(changes: SimpleChanges): void {
        // this.AuditReport();
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    setFilterCols(): void {
        this.cols = [];
        switch (this.selectedWindow) {
            case ReportsAuditRoutes["audit-report"]: {
                if (this.selectedModule?.id == 1) {
                    this.cols = [
                        { id: 1, field: 'sequenceNumber', header: 'ID No. ', dataType: ReportsColumnDataType.popuplink, popupLinkObject: { idColumn: 'leadId', module: 'Lead' } },
                        { id: 2, field: 'actionTypeName', header: 'Audit Type', dataType: ReportsColumnDataType.string },
                        { id: 3, field: 'actionDate', header: 'Created Date', dataType: ReportsColumnDataType.datetime },
                        { id: 4, field: 'userName', header: 'User', dataType: ReportsColumnDataType.string },
                        { id: 5, field: 'labelName', header: 'Field Name', dataType: ReportsColumnDataType.string },
                        { id: 6, field: 'oldValue', header: 'Old Value', dataType: ReportsColumnDataType.string },
                        { id: 7, field: 'newValue', header: 'New Value', dataType: ReportsColumnDataType.string },
                    ];
                }
                else if (this.selectedModule?.id == 2) {
                    this.cols = [
                        { id: 1, field: 'sequenceNumber', header: 'ID No. ', dataType: ReportsColumnDataType.popuplink, popupLinkObject: { idColumn: 'accountId', module: 'Account' } },
                        { id: 2, field: 'actionTypeName', header: 'Audit Type', dataType: ReportsColumnDataType.string },
                        { id: 3, field: 'actionDate', header: 'Created Date', dataType: ReportsColumnDataType.datetime },
                        { id: 4, field: 'userName', header: 'User', dataType: ReportsColumnDataType.string },
                        { id: 5, field: 'labelName', header: 'Field Name', dataType: ReportsColumnDataType.string },
                        { id: 6, field: 'oldValue', header: 'Old Value', dataType: ReportsColumnDataType.string },
                        { id: 7, field: 'newValue', header: 'New Value', dataType: ReportsColumnDataType.string },
                    ];
                }
                this.getAuditReport();
                break;
            }
            default: {
                break;
            }
        }
    }
    setFilterValues(reportsData: any[], applyType: 'apply' | 'modify' = 'apply'): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsAuditRoutes["audit-report"]:
                this.filterByInputValue = [...this.reportsData];
                break;
            default:
                this.filterByInputValue = [...this.reportsData];
                break;
        }
    }
    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);
        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {
                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    this.reportsData = this.reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.setFilterValues(this.reportsData);
    }
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportsData: any[] = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {

                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsAuditRoutes["audit-report"]:
                this.filterByInputValue = [...reportsData];
                break;
            default:
                this.filterByInputValue = [...reportsData];
                break;
        }
    }
    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }
    onChangeRange(selectedWindow: string, event: any): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        //this.selectedDateFilter = event;
        const selectedUser = this.selectedRepFilter;
        this.AuditReport();
    }
    AuditReport() {
        this.organizationName = this.app.user.organizationName;
        this.setFilterCols();
        // this.setFilterValues(this.reportsData);
    }

    getAuditReport(applyFilter: boolean = false): void {
        this.currentDateTime = new Date();
        this.appMainService.isShowSpinner(this.reportName);
        this.reportsData = [];
        this.reportService.getAuditReport(this.selectedWindow,
            this.selectedModule.id ?? 0,
            this.selectedChannel?.id ?? 0,
            0,
            this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo),
            this.pageNumber,
            this.pageSize,
        ).then((res) => {
            this.appMainService.isHideSpinner(this.reportName);
            let { reports, headers } = res;
            this.reportsData = reports;
            this.reportsDataCopy = ParseHelper.DeepCopy(reports);;
            this.reportsTotalRecord = headers["TotalCount"];
            if (applyFilter) {
                this.onApplyFilter(this.selectedWindow, []);
            }
            //set filter value
            this.setFilterValues(this.reportsData);

        },
            (err: any) => {
                this.appMainService.isHideSpinner(this.reportName);
                this.setFilterValues(this.reportsData);
                // this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.status == 400 ? err?.statusText : 'No Data Found...' });
            });
        /*.subscribe({
            next: (res) => {
                this.appMainService.isHideSpinner(this.reportName);
                let { reports } = res;
                this.reportsData = reports;
                this.reportsDataCopy = ParseHelper.DeepCopy(reports);;
                if (applyFilter) {
                    this.onApplyFilter(this.selectedWindow, []);
                }
                //set filter value
                //this.setFilterValues(this.reportDatas);

            },
            error: (err: any) => {
                this.appMainService.isHideSpinner(this.reportName);
                this.setFilterValues(this.reportsData);
                // this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.status == 400 ? err?.statusText : 'No Data Found...' });
            }
        });*/
    }

    private formatDate(date: Date): any {
        //Convert to UTC time
        let utcDate = this.app._saveDateTimeWithZone(date) ?? date;
        return moment(utcDate).format('MM-DD-YYYY');
    }

    getPaginationData(event: any) {
        // console.log(event);
        // const pageSize: number = event.rows;
        // const pageNumber: number = (event.first / event.rows) + 1;
        // this.pageSize = pageSize;
        // this.pageNumber = pageNumber;
        // this.AuditReport();
    }

    async onChangeModule(selectedWindow: string, event: any) {
        this.selectedModule = event;
        await this.setModuleChannel();
    }

    onChangeChannel(selectedWindow: string, event: any) {
        this.selectedChannel = event;
        this.AuditReport();
    }

    async getAuditReportModule() {
        this.moduleList = this.app.preLoadedObjects.filter(x => x?.id == 1 || x?.id == 2) ?? [];
        // this.moduleList = this.app.preLoadedObjects.filter(x => x?.id == 2) ?? [];
        this.selectedModule = this.moduleList[0] ?? null;
        await this.setModuleChannel();
    }

    async setModuleChannel() {
        switch (this.selectedModule?.id ?? 0) {
            case 1:
                this.channelList = await this.dataService.getLeadChannelList();
                this.selectedChannel = this.channelList[0] ?? null;
                break;
            case 2:
                this.channelList = await this.dataService.getAccountChannelList();
                this.selectedChannel = this.channelList[0] ?? null;
                break;
            default:
                this.channelList = [];
                this.selectedChannel = [];
                break;
        }
        this.AuditReport();
    }

    //#region //********Print And Export(PDF & Excel)***********//

    print(): void {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false): void {
        this.pdfInventoryReport(this.reportsData, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, isPrintFlag);
    }

    exportXLS(selectedWindow: string): void {
        this.excelExportInventoryReport(this.reportsData, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, "XLSX");
    }

    exportXLSX(selectedWindow: string): void {
        this.excelExportInventoryReport(this.reportsData, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, "XLSX");
    }

    pdfInventoryReport(data: any, cols: any, groupCol: IReportsColumnModel, selectedWindow: string, reportName: string, isPrintFlag: boolean): void {
        let dataResult = this.prepareExportDataResult(data, cols, groupCol, true);
        ReportsPrintPdfService.openOrExportAsPDF(this.setPDFColumns(cols), dataResult, this.organizationName, this.dateFrom, this.dateTo, reportName, null, null, isPrintFlag);
    }

    excelExportInventoryReport(data: any, cols: any, groupCol: IReportsColumnModel, selectedWindow: string, reportName: string, exportType: 'XLS' | 'XLSX'): void {
        let dataResult = this.prepareExportDataResult(data, cols, groupCol);
        ReportsExportExcelService.exportAsExcel(exportType, dataResult, this.organizationName, this.reportName);
    }

    //Get group column of grouptable
    getTableGroupColName(): IReportsColumnModel | null {
        return null;
    }

    //Prepare DataResutl For PDF/Excel
    prepareExportDataResult(data: any, cols: IReportsColumnModel[], groupCol: IReportsColumnModel, isPDF: boolean = false): any[] {
        const actData = ParseHelper.DeepCopy(data);
        const dataResult: any[] = [];
        let groupColValue = '';
        for (let data of actData) {
            const obj = {};
            for (let col of cols) {
                if (col.dataType == ReportsColumnDataType.date) {
                    obj[isPDF ? col.field : col.header] = this.localDatePipe.transform(data[col.field], 'MM/DD/YYYY')
                }
                else if (col.dataType == ReportsColumnDataType.datetime) {
                    obj[isPDF ? col.field : col.header] = this.localDatePipe.transform(data[col.field], 'MM/DD/YYYY | h:mm a')
                }
                else if (col.dataType == ReportsColumnDataType.number2dp) {
                    obj[isPDF ? col.field : col.header] = data[col.field]?.toFixed(2) ?? data[col.field];
                }
                // else if (col.dataType == 'currencySymbol') {
                //     obj[isPDF ? col.field : col.header] = this.currencySymbolPipe.transform(data[col.field], 'number2dp') ?? data[col.field];
                // }
                // else if (col.dataType == 'percentageSymbol') {
                //     obj[isPDF ? col.field : col.header] = this.percentageSymbolPipe.transform(data[col.field], 'number2dp') ?? data[col.field];
                // }
                // else if (col.dataType == 'timespan') {
                //     obj[isPDF ? col.field : col.header] = this.timeConvertPipe.transform(data[col.field]) ?? data[col.field];
                // }
                else {
                    obj[isPDF ? col.field : col.header] = data[col.field];
                }
            }
            //#endregion
            dataResult.push(obj);
        }
        return dataResult;
    }

    setPDFColumns(cols: IReportsColumnModel[]): any[] {
        let pdfcolumns: any[] = [];
        cols?.map(col => {
            pdfcolumns.push({ id: col.id, dataKey: col.field, header: col.header });
        });
        return pdfcolumns;
    }
    //#endregion

    onPopupLinkClick(event: IPopupLink) {
        if (this.selectedModule?.id == 1 && event?.rowData?.leadId > 0) {
            this.displayLeadViewEdit = true;
            this.selectedLeadId = event?.rowData?.leadId ?? 0;
            this.selectedChannelId = event?.rowData?.channelId ?? 0;
        }
        else if (this.selectedModule?.id == 2 && event?.rowData?.accountId > 0) {
            this.displayAccountViewEdit = true;
            this.selectedAccountId = event?.rowData?.accountId ?? 0;
            this.selectedChannelId = event?.rowData?.channelId ?? 0;
        }
    }

    getAccountListAfterEdit() {
        this.AuditReport();
    }

    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedChannelId = 0;
    }

    reloadResultAfterSave() {
        this.AuditReport();
    }

    closeLeadViewEdit() {
        this.displayLeadViewEdit = false;
        this.selectedLeadId = 0;
        this.selectedChannelId = 0;
    }

    refreshList(selectedWindow: string) {
        this.cols = [];
        // await this.getAuditReportModule();
        this.selectedFilterGroup = [];
        this.AuditReport();
    }
}
